import { decimalToTime } from "@/utils/date-time-formatter";
import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColGroupDef } from "ag-grid-enterprise";

export const useTableData = () => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Phases",
      children: [
        {
          field: "PhaseName",
          headerName: "Name",
          flex: 1,
          cellStyle: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            marginLeft: 15,
          },
          minWidth: 100,
        },
        {
          field: "Start",
          headerName: "Start",
          flex: 1,
          valueGetter: (params: any) => {
            if (params.data.Start) {
              return dxtToLocalServerTime(params.data.Start, "HH:mm");
            }
          },
          minWidth: 50,
        },
        {
          field: "End",
          headerName: "End",
          flex: 1,
          valueGetter: (params: any) => {
            if (params.data.End) {
              return dxtToLocalServerTime(params.data.End, "HH:mm");
            }
          },
          minWidth: 50,
        },
        {
          field: "Duration",
          headerName: "Duration",
          flex: 1,
          valueGetter: (params: any) => {
            if (params.data.Duration) {
              return decimalToTime(params.data.Duration);
            }
          },
          minWidth: 80,
        },
        {
          field: "MWH",
          headerName: "MWH",
          flex: 1,
        },
        {
          field: "InjectedCarbon",
          headerName: "Carbon Inj.",
          flex: 1,
          minWidth: 80,
        },
      ],
    },
  ];

  return { columns };
};
